import { BASE_API_URL } from '@env';
import { useMutation } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';

export const useInviteGuestViaEmail = () => {
  return useMutation(async ({ orderId, email, name }: { orderId: string; email: string; name: string }) => {
    const token = useUserStore.getState().token;
    const response = await fetch(`${BASE_API_URL}orders/pyxi-select/plus-one/share-link?order_id=${orderId}&email=${encodeURIComponent(email)}&name=${encodeURIComponent(name)}`, {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to send email invitation');
    }

    return await response.json();
  });
};